import { sanitizeHtml } from "./safeContent";

const GENERAL_NOTE =
  "(Необов’язкове до прочитання. Виключно для допитливих. Всіх інших просимо не заморочуватись. Ми не школа і не партія — нікого не вчимо й нікому нічого не доводимо.)";

export const ABOUT_AUTH_PLAIN_FIELDS = [
  {
    key: "authorTabLabel",
    group: "navigation",
    label: "Кнопка переходу до авторів",
    maxLength: 80,
  },
  {
    key: "artistTabLabel",
    group: "navigation",
    label: "Кнопка переходу до художників",
    maxLength: 80,
  },
  {
    key: "authorSectionTitle",
    group: "author",
    label: "Заголовок розділу для авторів",
    maxLength: 120,
  },
  {
    key: "authorGeneralTitle",
    group: "author",
    label: "Заголовок загального звернення до автора",
    maxLength: 240,
  },
  {
    key: "authorGeneralNote",
    group: "author",
    label: "Примітка під заголовком звернення",
    type: "textarea",
    maxLength: 2000,
  },
  {
    key: "authorOfferTitle",
    group: "author",
    label: "Заголовок публічної оферти",
    maxLength: 300,
  },
  {
    key: "authorRespectTitle",
    group: "author",
    label: "Заголовок блоку про повагу до роботи",
    maxLength: 300,
  },
  {
    key: "artistSectionTitle",
    group: "artist",
    label: "Заголовок розділу для художників",
    maxLength: 120,
  },
  {
    key: "artistGeneralTitle",
    group: "artist",
    label: "Заголовок загального звернення до художників",
    maxLength: 240,
  },
  {
    key: "artistGeneralNote",
    group: "artist",
    label: "Примітка під заголовком звернення",
    type: "textarea",
    maxLength: 2000,
  },
];

export const ABOUT_AUTH_RICH_FIELDS = [
  {
    key: "section1_intro",
    group: "author",
    label: "Вступ для авторів",
    placeholder: "Напишіть вступний текст...",
  },
  {
    key: "section1_general",
    group: "author",
    label: "Основний текст загального звернення до автора",
    placeholder: "Напишіть звернення...",
  },
  {
    key: "section1_desc",
    group: "author",
    label: "Опис для авторів",
    placeholder: "Опишіть деталі та умови...",
  },
  {
    key: "section1_offer",
    group: "author",
    label: "Текст публічної оферти",
    placeholder: "Напишіть текст оферти...",
  },
  {
    key: "section2_intronew",
    group: "author",
    label: "Текст блоку про повагу до роботи",
    placeholder: "Напишіть текст блоку...",
  },
  {
    key: "section2_intro",
    group: "artist",
    label: "Вступ для художників",
    placeholder: "Напишіть вступний текст...",
  },
  {
    key: "section2_post",
    group: "artist",
    label: "Контакти для художників",
    placeholder: "Вкажіть email або інструкції для зв’язку...",
  },
  {
    key: "section2_general",
    group: "artist",
    label: "Додатковий текст для художників",
    placeholder: "Напишіть додатковий текст...",
  },
  {
    key: "section2_desc",
    group: "artist",
    label: "Основний текст загального звернення до художників",
    placeholder: "Напишіть звернення...",
  },
];

export const ABOUT_AUTH_DEFAULT_CONTENT = Object.freeze({
  authorTabLabel: "Для авторів",
  artistTabLabel: "Для художників",
  authorSectionTitle: "Для авторів",
  authorGeneralTitle: "Загальне звернення до Автора.",
  authorGeneralNote: GENERAL_NOTE,
  authorOfferTitle: "Публічна оферта щодо розгляду Творів Автора рукописів",
  authorRespectTitle: "Просимо поваги до нашої роботи наступним чином:",
  artistSectionTitle: "Для художників",
  artistGeneralTitle: "Загальне звернення до Художників.",
  artistGeneralNote: GENERAL_NOTE,
  section1_intro: "",
  section1_general: "",
  section1_desc: "",
  section1_offer: "",
  section2_intronew: "",
  section2_intro: "",
  section2_post: "",
  section2_general: "",
  section2_desc: "",
});

export function resolveAboutAuthContent(raw = {}) {
  return Object.keys(ABOUT_AUTH_DEFAULT_CONTENT).reduce((result, key) => {
    result[key] =
      typeof raw?.[key] === "string"
        ? raw[key]
        : ABOUT_AUTH_DEFAULT_CONTENT[key];
    return result;
  }, {});
}

export function prepareAboutAuthContent(content) {
  const resolved = resolveAboutAuthContent(content);

  ABOUT_AUTH_PLAIN_FIELDS.forEach(({ key, label, maxLength }) => {
    const value = resolved[key].trim();
    if (value.length > maxLength) {
      throw new Error(`Поле «${label}» перевищує ${maxLength} символів.`);
    }
    resolved[key] = value;
  });

  ABOUT_AUTH_RICH_FIELDS.forEach(({ key, label }) => {
    if (resolved[key].length > 50000) {
      throw new Error(`Поле «${label}» перевищує 50 000 символів.`);
    }
    resolved[key] = sanitizeHtml(resolved[key]);
  });

  return resolved;
}
